import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { Careers } from "./pages/Careers";
import { CareerDetail } from "./pages/CareerDetail";
import { Convalidation } from "./pages/Homologation";
import { WhyMIT } from "./pages/WhyMIT";
import { Admission } from "./pages/Admission";
import { Contact } from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/carreras" element={<Careers />} />
          <Route path="/carreras/:id" element={<CareerDetail />} />
          <Route path="/convalidacion" element={<Convalidation />} />
          <Route path="/por-que-mit" element={<WhyMIT />} />
          <Route path="/admision" element={<Admission />} />
          <Route path="/contacto" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
